import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";

import {
    actionGetOrderLocationsByDisplayArea, actionShopcartResetOrderProducts,
    actionResetPaymentTransaction
} from 'actions'

import { actionStartAppLoader, actionEndAppLoader } from 'actions/actionAppLoader';
import ErrorHandling from 'components/ErrorHandling/ErrorHandling';
import OrderLocationItem from './components/OrderLocationItem'

const { } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(5)
        }
    },
}));

const OrderLocationScreen = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const [errorMsg, seterrorMsg] = useState("");

    const payment = useSelector(state => state.reducerPaymentTransaction.Payment);
    const orderLocationsLoading = useSelector(state => state.reducerOrderLocations.loading);
    const orderLocations = useSelector(state => state.reducerOrderLocations.orderLocations);

    useEffect(() => {
        if (payment && payment.ReceiptNo && payment.ReceiptNo.toString().length > 0) {
            actionResetPaymentTransaction(dispatch);
        }
    }, []);

    useEffect(() => {
        let areaNo = 0;

        if (props.match.path == "/orderlocation/Area/:id")
            areaNo = props.match.params.id;

        actionGetOrderLocationsByDisplayArea(dispatch, areaNo);
    }, [])

    useEffect(() => {
        if (orderLocationsLoading) {
            actionStartAppLoader(dispatch);
        }
        else {
            actionEndAppLoader(dispatch);
        }
    }, [orderLocationsLoading])

    useEffect(() => {
        if (orderLocations && orderLocations.length == 1) {
            actionShopcartResetOrderProducts(dispatch);
            props.history.push('/orderlocationtab/' + orderLocations[0].OrderLocation);
        }
    }, [orderLocationsLoading])

    const errorcancelhandle = () => {
        seterrorMsg("");
    }
    return (
        <Grid className={classes.root} container spacing={2} justify="center">
            <ErrorHandling msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />
            <Grid item xs={12} md={6} lg={5}>
                <img
                    width={"100%"}
                    height={"100%"}
                    alt="Logo"
                    src={process.env.PUBLIC_URL + "/images/orderLocationMap.png"}
                />
            </Grid>
            <Grid item xs={12} md={6} lg={5}>
                {orderLocations.map(location => {
                    return (<OrderLocationItem key={location.OrderLocation} Location={location} {...props} />)
                })}
            </Grid>
        </Grid>
    );
};

export default OrderLocationScreen;
